import React from "react";
import { Box, Grid } from "@mui/material";
import {
  InfoOutlined,
  Inventory2Outlined,
  DescriptionOutlined,
} from "@mui/icons-material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import { useSendOutCollectionDetailContext } from "contexts/SendOutCollectionDetailContext";
import { localizeDateTimeShort } from "utils/dateFormats";

const SendOutCollectionBasicDetail = () => {
  const { sendOutCollectionDetail, loadingSendOutCollection } =
    useSendOutCollectionDetailContext();

  return !loadingSendOutCollection ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        {/* Collection ID */}
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="Collection ID"
            subtitle={sendOutCollectionDetail?.sendOutCollectionId}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="SendOut ID"
            subtitle={sendOutCollectionDetail?.sendOutId?.sendOutId}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={sendOutCollectionDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created At"
            subtitle={localizeDateTimeShort(sendOutCollectionDetail?.createdAt)}
          />
        </Grid>

        {/* Updated At */}
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Updated At"
            subtitle={localizeDateTimeShort(sendOutCollectionDetail?.updatedAt)}
          />
        </Grid>

        {/* Status */}
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={sendOutCollectionDetail?.isActive} />
          </InformationTile>
        </Grid>
        {/* Description */}
        <Grid item xs={12}>
          <InformationTile
            icon={() => <DescriptionOutlined color="primary" />}
            title="Description"
            subtitle={sendOutCollectionDetail?.description}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default SendOutCollectionBasicDetail;
